import { TextWithContentModel } from '../model/TextWithContentModel';

interface TextWithContentPreviewHeaderProps {
  content: TextWithContentModel;
  languageCode: string;
}

export const TextWithContentPreviewHeader = ({ content, languageCode }: TextWithContentPreviewHeaderProps) => {
  const getLanguageContent = () => {
    if (content.titleNContent && content.titleNContent[languageCode]) {
      const languageConent = content.titleNContent[languageCode];
      return languageConent;
    }
    if (content.titleNContent) return content.titleNContent['hu'];

    return { title: '', description: '', ctaText: '', ctaLink: '' };
  };

  const handleNavigationButtonClick = () => {
    // @ts-ignore
    if (window.isAdminPage) return;

    window.location.href = getLanguageContent().ctaLink;
  };
  return (
    <div className='textContent flex flex-col min-[350px]:gap-2 min-[350px]:mb-2 sm:gap-3 min-[350px]:px-5 sm:px-0 w-full md:w-1/2'>
      <h1 className='font-body min-[350px]:text-[30px] sm:text-[35px] lg:text-[40px] font-semibold leading-normal' style={{ color: content.textColor }}>
        {getLanguageContent().title}
      </h1>
      <div className='w-16 h-[2px] min-[350px]:my-2 md:my-0 lg:my-2 z-[0]' style={{ background: content.dividerColor }}></div>
      <p
        className='min-[350px]:text-[14px] md:text-[16px] lg:text-[18px] max-w-[580px] font-normal min-[350px]:leading-normal font-body'
        style={{ color: content.textColor }}
        dangerouslySetInnerHTML={{ __html: getLanguageContent().description }}
      ></p>
      {getLanguageContent().ctaText !== '' && getLanguageContent().ctaLink !== '' && (
        <button
          type='button'
          onClick={handleNavigationButtonClick}
          className='py-2 font-body px-3 w-fit rounded font-semibold mb-3 md:mb-0 min-[350px]:text-sm md:text-base outline-none focus:border-none focus:outline-none'
          style={{ background: content.buttonColor, color: content.buttonTextColor }}
        >
          {getLanguageContent().ctaText}
        </button>
      )}
    </div>
  );
};
